import PosthogService from '~/services/posthog/PosthogService';
import { POSTHOG_EVENTS } from '~/services/posthog/events';

/**
 * Fires when the office clicks Log Out in the account area, before confirming.
 * Event: office:logout:clicked
 *
 * The legacy name is kept verbatim: the series is live, and renaming it would
 * fork every insight built on it.
 */
export function fireOfficeLogoutClicked(): void {
  PosthogService.getInstance().track(POSTHOG_EVENTS.OFFICE_LOGOUT_CLICKED);
}
